import React from "react";
import { Grid } from "grommet";
import { ImageWithLink } from "../ImageWithLink";
export var NewsSubSection = function NewsSubSection(_ref) {
  var subNewsList = _ref.subNewsList,
    newsList = _ref.newsList,
    app_api = _ref.app_api,
    as = _ref.as;
  return /*#__PURE__*/ React.createElement(
    Grid,
    {
      columns: {
        count: "fit",
        size: "330px",
      },
      gap: "24px",
    },
    newsList.slice(5).map(function (newsItem) {
      return /*#__PURE__*/ React.createElement(ImageWithLink, {
        as: as,
        key: newsItem.public_id,
        image: "" + app_api + newsItem.banners.small,
        heading: newsItem.headline,
        publication_date: newsItem.publication_date,
        link: newsItem.public_id,
      });
    })
  );
};
